// ButtonStyled.js
import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'

export const StackInfoItem = styled(Stack)(
  ({ theme }) =>
    ({ isWithImg, isService }) => ({
      display: 'flex',
      flexDirection: isService ? 'column' : 'row',
      gap: '1rem',
      width: isWithImg ? '50%' : '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        paddingRight: '2rem',
        textAlign: 'left',
      },
    })
)
